import axios from '../../config/axios.js';
import Alpine from 'alpinejs';

function newsArticleDetail(cfg) {
  return {
    slug: cfg.slug,
    shareUrl: cfg.shareUrl,
    shareText: cfg.shareText,
    loginUrl: cfg.loginUrl,
    state: { ...cfg.userState },
    counts: { ...cfg.counts },
    comments: cfg.comments || [],
    xpRewards: cfg.xpRewards || {},
    commentText: '',
    acting: false,

    isLoggedIn() {
      return !!Alpine.store('auth')?.isLoggedIn;
    },

    requireLogin() {
      window.toast?.('Login dulu untuk berinteraksi dan dapat XP.', 'info');
      window.location.href = this.loginUrl;
    },

    async interact(type, extra = {}) {
      if (!this.isLoggedIn()) {
        this.requireLogin();
        return;
      }
      if (this.state[type]) return;

      this.acting = true;
      try {
        const { data } = await axios.post(`/api/v1/news/${this.slug}/interact`, { type, ...extra });
        if (data.data?.user_actions) Object.assign(this.state, data.data.user_actions);
        else this.state[type] = true;
        if (data.data?.counts) Object.assign(this.counts, data.data.counts);
        if (type === 'comment' && extra.comment) {
          this.comments.unshift({
            id: Date.now(),
            user_name: Alpine.store('auth')?.user?.name || 'Anda',
            comment: extra.comment,
            created_at: 'baru saja',
          });
          this.commentText = '';
        }
        const xp = data.data?.xp_awarded ?? 0;
        const msg = data.message || 'Berhasil.';
        window.toast?.(msg + (xp > 0 ? ` (+${xp} XP)` : ''), 'success');
      } catch (e) {
        const msg = e.response?.data?.message || 'Gagal memproses.';
        if (e.response?.status === 401) this.requireLogin();
        else window.toast?.(msg, 'error');
      } finally {
        this.acting = false;
      }
    },

    like() {
      this.interact('like');
    },

    comment() {
      const text = this.commentText.trim();
      if (!text) return;
      this.interact('comment', { comment: text });
    },

    async share() {
      if (this.state.share) return;

      const payload = { title: this.shareText, url: this.shareUrl, text: this.shareText };

      try {
        if (navigator.share) {
          await navigator.share(payload);
        } else {
          await navigator.clipboard.writeText(this.shareUrl);
          window.toast?.('Link disalin ke clipboard.', 'success');
        }
      } catch (e) {
        if (e?.name === 'AbortError') return;
        try {
          await navigator.clipboard.writeText(this.shareUrl);
          window.toast?.('Link disalin.', 'success');
        } catch {
          window.prompt('Salin link berita:', this.shareUrl);
        }
      }

      await this.interact('share');
    },
  };
}

Alpine.data('newsArticleDetail', newsArticleDetail);
